// pricing_tabs — ARIA tablist for the pricing page plan groups.
// The active tab is mirrored to the URL hash (#business, #agency, #enterprise)
// so each offering can be linked to directly.
import { Controller } from '@hotwired/stimulus'

import { trackEvent } from 'api/index'

export default class extends Controller {
  static targets = ['tab', 'panel']

  connect() {
    this.onHashChange = () => this.#select(this.#hashTab())
    window.addEventListener('hashchange', this.onHashChange)
    this.#select(this.#hashTab())
    delete this.element.dataset.initialTab
  }

  disconnect() {
    window.removeEventListener('hashchange', this.onHashChange)
  }

  activate(event) {
    const tab = event.currentTarget
    const id = tab.dataset.tab
    if (tab.getAttribute('aria-selected') !== 'true') {
      trackEvent('Marketing:Pricing:Tab selected', { tab: id })
    }

    this.#select(id)
    history.replaceState(null, '', `#${id}`)
  }

  talkToSales({ params: { solution, placement } }) {
    trackEvent('Marketing:Pricing:Talk to sales clicked', {
      solution,
      placement
    })
  }

  billingPeriod(event) {
    trackEvent('Marketing:Pricing:Billing period changed', {
      period: event.target.checked ? 'annual' : 'monthly'
    })
  }

  nav(event) {
    const tabs = this.tabTargets
    const i = tabs.indexOf(event.currentTarget)
    const next = {
      ArrowLeft: (i - 1 + tabs.length) % tabs.length,
      ArrowRight: (i + 1) % tabs.length,
      Home: 0,
      End: tabs.length - 1
    }[event.key]
    if (next === undefined) return

    event.preventDefault()
    tabs[next].focus()
    tabs[next].click()
  }

  #hashTab() {
    return window.location.hash.slice(1)
  }

  #select(id) {
    if (!this.tabTargets.some(tab => tab.dataset.tab === id)) return

    this.tabTargets.forEach(tab => {
      const active = tab.dataset.tab === id
      tab.setAttribute('aria-selected', String(active))
      tab.tabIndex = active ? 0 : -1
    })
    this.panelTargets.forEach(panel => {
      panel.hidden = panel.dataset.tab !== id
    })
  }
}
